import { ComponentProps } from 'react';

import { Avatar as MuiAvatar, SxProps } from '@mui/material';

// TODO: Move to componentLibrary (Design System) with proper story and documentation

const SYSTEM_AVATARS = [
    '/static/images/avatars/Avatar_B_01.png',
    '/static/images/avatars/Avatar_B_02.png',
    '/static/images/avatars/Avatar_B_03.png',
    '/static/images/avatars/Avatar_B_04.png',
    '/static/images/avatars/Avatar_B_05.png',
    '/static/images/avatars/Avatar_B_06.png',
    '/static/images/avatars/Avatar_B_07.png',
    '/static/images/avatars/Avatar_B_08.png',
    '/static/images/avatars/Avatar_B_09.png',
    '/static/images/avatars/Avatar_B_10.png',
    '/static/images/avatars/Avatar_B_11.png',
    '/static/images/avatars/Avatar_B_12.png',
    '/static/images/avatars/Avatar_B_13.png',
    '/static/images/avatars/Avatar_B_14.png',
    '/static/images/avatars/Avatar_B_15.png',
    '/static/images/avatars/Avatar_B_16.png',
    '/static/images/avatars/Avatar_B_17.png',
    '/static/images/avatars/Avatar_B_18.png',
    '/static/images/avatars/Avatar_B_19.png',
    '/static/images/avatars/Avatar_B_20.png',
];

const hashString = (str: string) => {
    let hash = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < str.length; i++) {
        // eslint-disable-next-line no-bitwise
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        // eslint-disable-next-line no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
};

interface IAvatarProps {
    src?: string;
    firstName?: string;
    sx?: SxProps;
    avatarUrl?: string;
}

const Avatar = ({ src, firstName, sx, avatarUrl }: IAvatarProps) => {
    const props: ComponentProps<typeof MuiAvatar> = {
        className: 'avatar',
        src,
        sx,
    };

    const getRandomAvatar = (name?: string) => {
        if (!name) {
            return SYSTEM_AVATARS[Math.floor(Math.random() * SYSTEM_AVATARS.length)];
        }

        const hash = hashString(name.toLowerCase());
        return SYSTEM_AVATARS[hash % SYSTEM_AVATARS.length];
    };

    return (
        <>
            {avatarUrl ? (
                <Avatar firstName={firstName} src={avatarUrl} sx={{ width: 25, height: 25 }} />
            ) : (
                <MuiAvatar {...props} src={src || getRandomAvatar(firstName)} />
            )}
        </>
    );
};

export default Avatar;
